var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.5C10.2909 8.5 8.5 10.2909 8.5 12.5V27.5C8.5 29.7091 10.2909 31.5 12.5 31.5H21.75C22.3735 31.5 22.9637 31.3573 23.4897 31.1029C22.2232 30.062 21.3705 28.3579 21.2849 26.4118H10.4166V24.4118H21.4741C21.6557 23.6549 21.9572 22.9583 22.3525 22.3529H10.4166V20.3529H23.1944V21.3354C23.9128 20.6494 24.7901 20.1897 25.75 20.0471V12.5C25.75 10.2909 23.9591 8.5 21.75 8.5H12.5ZM10.4166 14.2353H23.1944V12.2353H10.4166V14.2353ZM23.1944 18.2941H10.4166V16.2941H23.1944V18.2941Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0279 30.8241C29.4978 30.8241 31.5001 28.704 31.5001 26.0888C31.5001 23.4736 29.4978 21.3535 27.0279 21.3535C24.5579 21.3535 22.5557 23.4736 22.5557 26.0888C22.5557 28.704 24.5579 30.8241 27.0279 30.8241ZM30.1035 25.2762C30.4019 24.989 30.411 24.5142 30.1237 24.2157C29.8365 23.9173 29.3617 23.9083 29.0633 24.1955L26.2001 26.9515C26.1077 27.0405 25.963 27.0451 25.8651 26.9622L24.957 26.193C24.641 25.9253 24.1677 25.9645 23.9 26.2805C23.6323 26.5966 23.6715 27.0698 23.9875 27.3376L24.8956 28.1068C25.5806 28.687 26.5936 28.6548 27.2403 28.0322L30.1035 25.2762Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.089f8992799abdb7c450d340221fb476.svg";
export { ForwardRef as ReactComponent };